export default {
	name: 'DogRequestOrdersView',
}